import Latex from 'react-latex';
import 'katex/dist/katex.min.css'; 
import { forwardRef, useEffect, useState } from 'react';
interface LatexComponentProps {
  equationInput: string;
  textInput: string;
}

const LatexComponent = forwardRef<HTMLDivElement, LatexComponentProps>(({ equationInput, textInput }, ref) => {

  const [equation, setEquation] = useState<string>('');
 //  const [text, setText] = useState<string>('');

  useEffect(() => {
    setEquation('$' + equationInput + '$');
    // setText(textInput);
  }, [equationInput, textInput]);
  
  return (
    <div
      className="latex-container"
      ref={ref}
      tabIndex={-1} 
      aria-hidden="true"
    >
      <div tabIndex = {-1} aria-hidden ="true">
        <span tabIndex={-1} aria-hidden="true">
          <Latex>
            {equation}
          </Latex>
        </span>
      </div>
    </div>
  );
});

export default LatexComponent;